import React from 'react';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import styles from './LandingPageV4.module.css';
import quickveeLogo from '../../Assets/Store/quickveeLogo.svg';

// Social icon SVGs
const FacebookIcon = () => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.324v-21.35c0-.732-.593-1.325-1.325-1.325z" />
  </svg>
);

const XIcon = () => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const YouTubeIcon = () => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const InstagramIcon = () => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.981 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.669-.072-4.949-.2-4.358-2.621-6.78-6.981-6.98C15.669.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.innerWrapper}>
        <div className={styles.footerContent}>
          <div className={styles.footerGrid}>
            {/* Brand column */}
            <div className={styles.footerBrand}>
              <a href="/" aria-label="Quickvee home">
                <img
                  src={quickveeLogo}
                  alt="Quickvee"
                  className={styles.footerLogo}
                  width="314"
                  height="94"
                />
              </a>
              <p className={styles.footerBrandDescription}>
                Local smoke and vape shopping, made simpler—from nearby shelf
                to your hands.
              </p>
              <div className={styles.footerSocial}>
                <a href="https://www.facebook.com/quickveepos/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FacebookIcon />
                </a>
                <a href="https://x.com/quickvee" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                  <XIcon />
                </a>
                <a href="https://www.instagram.com/quickvee/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <InstagramIcon />
                </a>
                <a href="https://www.youtube.com/@Quickvee" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <YouTubeIcon />
                </a>
              </div>
            </div>

            {/* Explore column */}
            <div className={styles.footerColumn}>
              <h4>Explore</h4>
              <ul>
                <li><a href="/about-us">About Us</a></li>
                <li>
                  <a href="https://merchants.quickvee.com" target="_blank" rel="noopener noreferrer">
                    Partner with us
                  </a>
                </li>
                <li>
                  <a href="https://www.quickvee.com/merchants/login" target="_blank" rel="noopener noreferrer">
                    Merchant Portal
                  </a>
                </li>
              </ul>
            </div>

            {/* Company column */}
            <div className={styles.footerColumn}>
              <h4>Support</h4>
              <ul>
                <li><a href="https://help.quickvee.com/hc/en-us" target="_blank" rel="noopener noreferrer">Help Center</a></li>
                <li><a href="https://merchants.quickvee.com/" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
                <li><a href="https://help.quickvee.com/hc/en-us" target="_blank" rel="noopener noreferrer">FAQs</a></li>
              </ul>
            </div>

            {/* Legal column */}
            <div className={styles.footerColumn}>
              <h4>Legal</h4>
              <ul>
                <li><a href="/terms-condition">Terms of Service</a></li>
                <li><a href="/privacy-policy">Privacy Policy</a></li>
              </ul>
            </div>

            {/* Help column */}
            <div className={styles.footerColumn}>
              <h4>Let Us Help You</h4>
              <p className={styles.footerHelpText}>
                Questions? Our support team is ready to help.
              </p>
              <ul>
                <li>
                  <a href="mailto:support@quickvee.com" className={styles.footerContactLink}>
                    <MailIcon sx={{ fontSize: 17 }} aria-hidden="true" />
                    <span>support@quickvee.com</span>
                  </a>
                </li>
                <li>
                  <a href="tel:18003901940" className={styles.footerContactLink}>
                    <PhoneIcon sx={{ fontSize: 17 }} aria-hidden="true" />
                    <span>1-800-390-1940</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.footerBottom}>
            <p className={styles.footerCopyright}>
              &copy; 2026 Quickvee. All rights reserved.
            </p>
            <div className={styles.footerBadges}>
              <span className={styles.footerBadge}>
                <VerifiedUserIcon sx={{ fontSize: 16 }} aria-hidden="true" />
                Secure Payments
              </span>
              <span className={styles.footerBadge}>
                <EventAvailableIcon sx={{ fontSize: 16 }} aria-hidden="true" />
                Age Verified
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
